import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/app/src/app/login/LoginForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SilkBackground"] */ "/app/src/components/SilkBackground.tsx");
